import dynamic from "next/dynamic";
import HeadsetIcon from "@mui/icons-material/Headset";
import VisibilityIcon from "@mui/icons-material/Visibility";
import TimerIcon from "@mui/icons-material/Timer";

import GridItem from "components/Grid/GridItem";
import VideoPlayer from "../../components/VideoPlayer/VideoPlayer";
import { Reviews } from "../../components/Reviews/Reviews";

const Spotify = dynamic(() =>
  import("react-spotify-embed").then((mod) => mod.Spotify)
);
const ContentHighlights = (props) => {
  const { user, processedReviews } = props;

  const { isSameVideo, latestReview, mostViewedReview, allReviews } =
    processedReviews;
  const { spotifyLink } = user.athleteDetails;

  if (!allReviews?.length && !spotifyLink) {
    return <div />;
  }

  const iconProps = { sx: { verticalAlign: "middle", mr: 1 } };

  const gridSizes = { md: 4, sm: 6, xxs: 12 };
  return (
    <>
      {latestReview ? (
        <GridItem {...gridSizes}>
          <h4>
            {!isSameVideo ? (
              <>
                <TimerIcon {...iconProps} />
                Latest review
              </>
            ) : (
              "Latest & Most watched review"
            )}
          </h4>
          {latestReview.reviewDetails.videoReview?.url ? (
            <VideoPlayer hideChannel noCarousel videos={[latestReview]} />
          ) : (
            <Reviews expertReviews={[latestReview]} noCarousel />
          )}
        </GridItem>
      ) : (
        ""
      )}
      {!isSameVideo && mostViewedReview ? (
        <GridItem {...gridSizes}>
          <h4>
            <VisibilityIcon {...iconProps} />
            Most viewed
          </h4>
          <VideoPlayer noCarousel hideChannel videos={[mostViewedReview]} />
        </GridItem>
      ) : (
        ""
      )}
      {spotifyLink && (
        <GridItem {...gridSizes}>
          {" "}
          <h4>
            <HeadsetIcon {...iconProps} />
            Currently running to
          </h4>
          <Spotify link={spotifyLink} />
        </GridItem>
      )}
    </>
  );
};

export default ContentHighlights;
